<template>
  <div class="home">
    <div class="box-container">X · Charts</div>
  </div>
</template>
<style lang="scss">
.box-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 700;
  font-size: 50px;
}
</style>
<script>
export default {
  name: 'Home'
}
</script>
